(function ($) {
    $(function () {

        const accordians = document.querySelectorAll('[data-accordian]');

        let accordianCount = 0;

        const initialiseAccordian = (accordian) => {
            if (accordian.dataset.accordianInitialised === 'true') {
                return;
            }

            accordian.dataset.accordianInitialised = 'true';
            accordianCount += 1;

            const accordianId = `accordian-${accordianCount}`;
            const items = accordian.querySelectorAll('[data-accordian-item]');
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

            const updateItem = (item, expanded, animate = true) => {
                const trigger = item.querySelector('[data-accordian-trigger]');
                const panel = item.querySelector('[data-accordian-panel]');

                if (!trigger || !panel) {
                    return;
                }

                item.classList.toggle('is-open', expanded);
                trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');

                if (!animate || reduceMotion.matches) {
                    panel.hidden = !expanded;
                    panel.style.height = expanded ? 'auto' : '0px';
                    return;
                }

                if (expanded) {
                    panel.hidden = false;
                    panel.style.height = '0px';

                    // Force the browser to apply the collapsed height before expanding.
                    panel.offsetHeight;
                    panel.style.height = `${panel.scrollHeight}px`;
                    return;
                }

                // Start from the panel's current rendered height before collapsing.
                panel.hidden = false;
                panel.style.height = `${panel.scrollHeight}px`;

                // Force the browser to apply the expanded height before collapsing.
                panel.offsetHeight;
                panel.style.height = '0px';
            };

            items.forEach((item, itemIndex) => {
                const trigger = item.querySelector('[data-accordian-trigger]');
                const panel = item.querySelector('[data-accordian-panel]');

                if (!trigger || !panel) {
                    return;
                }

                const triggerId = `${accordianId}-trigger-${itemIndex + 1}`;
                const panelId = `${accordianId}-panel-${itemIndex + 1}`;
                const startsOpen = item.classList.contains('is-open');

                trigger.id = triggerId;
                trigger.setAttribute('aria-controls', panelId);

                panel.id = panelId;
                panel.setAttribute('role', 'region');
                panel.setAttribute('aria-labelledby', triggerId);

                updateItem(item, startsOpen, false);

                panel.addEventListener('transitionend', (event) => {
                    if (event.propertyName !== 'height') {
                        return;
                    }

                    const isOpen = item.classList.contains('is-open');

                    if (isOpen) {
                        panel.style.height = 'auto';
                    } else {
                        panel.hidden = true;
                    }
                });

                trigger.addEventListener('click', () => {
                    const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
                    updateItem(item, shouldOpen);
                });
            });

            accordian.classList.add('is-initialised');
        };

        accordians.forEach((accordian) => {
            initialiseAccordian(accordian);
        });
        

    });
})(jQuery);
